<template>
  <v-container>
    <v-card outlined>
      <v-card-title>
        <v-layout>
          <v-flex xs4>
            <!-- <div class="subtitle-2 mb-1">Select Region</div> -->
            <v-select
              outlined
              dense
              hide-details
              return-object
              :items="regionsWithAll"
              v-model="selectedRegion"
              item-text="name"
              placeholder="Select Region"
              @change="selectRegion"
            >
            </v-select>
          </v-flex>

          <v-flex text-right>
            <v-btn @click="openNewCrawlerDialog" depressed color="primary">
              Create New Crawler
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-layout class="mx-4">
        <v-flex xs4>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="headers"
        :items="crawlers"
        :items-per-page="30"
        class="elevation-0"
        :search="search"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
        </template>
        <template v-slot:item.lastChecked="{ item }">
          <div>
            {{ iMoment(item.lastChecked) }}
          </div>
        </template>
        <template v-slot:item.lastPostOnIG="{ item }">
          <div>
            {{ iMoment(item.lastPostOnIG) }}
          </div>
        </template>
        <template v-slot:item.createdAt="{ item }">
          <div>
            {{ iMoment(item.createdAt) }}
          </div>
        </template>
      </v-data-table>
    </v-card>
    <new-crawler-dialog :collection="collection" ref="newCrawlerDialog" />
    <edit-crawler-dialog
      :collection="collection"
      :details="editedItem"
      ref="editCrawlerDialog"
    />
    <v-dialog v-model="dialogDelete" width="300">
      <v-card>
        <v-card-title>Are you sure you want to delete this item?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="error"
            class="text-none subtitle-2"
            @click="dialogDelete = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            class="text-none subtitle-2"
            text
            @click="deleteItemConfirm"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import NewCrawlerDialog from "../components/NewCrawlerDialog";
import EditCrawlerDialog from "../components/EditCrawlerDialog";
import { mapActions, mapState } from "vuex";
import moment from "moment";
export default {
  components: {
    NewCrawlerDialog,
    EditCrawlerDialog,
  },
  data() {
    return {
      search: "",
      collection: "entityProfilesToCrawl",
      dialogDelete: false,
      selectedRegion: {},
      itemToDelete: {
        name: "",
        latitude: "",
        longitude: "",
      },
      headers: [
        {
          text: "Subscriber",
          align: "start",
          sortable: true,
          value: "entity.title",
        },
        {
          text: "Region",
          value: "entity.region.name",
        },
        {
          text: "Last Crawled",
          value: "lastChecked",
        },
        {
          text: "Last Post on IG",
          value: "lastPostOnIG",
        },
        // { text: "Font Family", value: "fontFamily" },
        // { text: "Font Name", value: "fontName" },
        // { text: "Background Color", value: "backgroundColor" },
        // { text: "Font Color", value: "fontColor" },
        { text: "Created At", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      editedItem: {
        name: "",
        latitude: "",
        longitude: "",
      },
      editedIndex: -1,
      defaultItem: {
        name: "",
        latitude: "",
        longitude: "",
      },
      //   pins: [
      //     {
      //       name: "Events",
      //       fontFamily: "MeterialDesignIcons",
      //       fontName: "",
      //       backgroundColor: "",
      //       fontColor: "",
      //     },
      //   ],
    };
  },
  computed: {
    ...mapState("$_entity", ["crawlers"]),
    ...mapState("$_home", ["regions"]),
    regionsWithAll() {
      var arr = [];

      arr.push({ name: "All" });
      arr = arr.concat(this.regions);
      return arr;
    },
  },
  created() {
    if (this.crawlers.length === 0) {
      this.getCrawlers({
        type: "crawler",
        collection: this.collection,
        mutation: "updateCrawlers",
      });
    }
    if (this.regions.length === 0) {
      this.getRegions({ collection: "regions", mutation: "updateRegions" });
    }
  },
  methods: {
    ...mapActions({
      getCrawlers: "$_entity/getSubscribers",
      getCrawlersByRegion: "$_entity/getSubscribersByRegion",
      deleteCrawler: "$_entity/deleteSubscriber",
      getRegions: "$_home/getContent",
    }),
    selectRegion() {
      // console.log("selectedRegion: ", this.selectedRegion);
      if (this.selectedRegion.name == "All") {
        this.getCrawlers({
          type: "crawler",
          collection: this.collection,
          mutation: "updateCrawlers",
        });
      } else {
        this.getCrawlersByRegion({
          type: "crawler",
          collection: "entityProfilesToCrawl",
          mutation: "updateCrawlers",
          region: this.selectedRegion,
        });
      }
    },
    iMoment(timestamp) {
      if (timestamp) {
        let temp = timestamp.seconds * 1000;
        return moment(temp).format("lll");
      } else {
        return 0;
      }
    },
    openNewCrawlerDialog() {
      this.$refs.newCrawlerDialog.toggleDialog();
    },
    editItem(item) {
      this.editedIndex = this.crawlers.indexOf(item);
      this.editedItem = Object.assign({}, this.crawlers[this.editedIndex]);

      console.log("Edited Item: ", this.editedItem);

      this.$refs.editCrawlerDialog.toggleDialog(this.editedItem);
    },
    deleteItem(item) {
      this.editedIndex = this.crawlers.indexOf(item);
      this.itemToDelete = Object.assign({}, this.crawlers[this.editedIndex]);
      this.dialogDelete = true;

      console.log(item);
    },
    deleteItemConfirm() {
      this.deleteCrawler({
        details: this.itemToDelete,
        type: "crawler",
        collection: this.collection,
      }).then(() => {
        this.dialogDelete = false;

        this.getCrawlers({
          type: "crawler",
          collection: this.collection,
          mutation: "updateCrawlers",
        });
      });
    },
  },
};
</script>

<style>
</style>